import { CommonsV1ApiBase } from './base';
import { EventIndexView, EventShowView } from '../types/events';
import { EventId } from '../../commonv3/types/events';
import { Service } from '../../commonv3/types/service';

export const EventApis = {
  base() {
    return CommonsV1ApiBase.appendPath('events');
  },
  findAll(): Promise<EventIndexView[]> {
    return this.base().get({ current_service: Service.LIKES });
  },
  find(eventId: EventId): Promise<EventShowView> {
    return this.base().withId(eventId).get({ current_service: Service.LIKES });
  },
};
